// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';

type VideoCoverPropTypes = {|
  className?: string,
  url: string,
|};

const VideoCover = (props: VideoCoverPropTypes) => {
  const style = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const [isIE, setIsIE] = React.useState(false);
  React.useEffect(() => {
    const isIEBrowser =
      typeof window !== 'undefined' && /MSIE|Trident|Edge/.test(window.navigator.userAgent);
    setIsIE(isIEBrowser);
  }, []);

  if (isIE) {
    // IE 11 fallback to fix object-fit: cover
    return <VideoCoverFallback {...props} />;
  }

  return (
    <div className={cx(styles.videoContainer, props.className)}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video playsInline autoPlay muted loop style={style}>
        <source src={props.url} type="video/mp4" />
      </video>
    </div>
  );
};

const VideoCoverFallback = (props: VideoCoverPropTypes) => {
  const [innerRatio, setInnerRatio] = React.useState(0);
  const [outerRatio, setOuterRatio] = React.useState(0);
  const videoContainer = React.useRef();

  const containerStyle = {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  };

  const style = {
    width: innerRatio > outerRatio ? 'auto' : '100%',
    height: innerRatio > outerRatio ? '100%' : 'auto',
    // the below styles are for centering the video on IE 11
    position: 'absolute',
    top: '50%',
    left: '50%',
    margin: 'auto',
  };

  const updateContainerRatio = () => {
    if (videoContainer.current) {
      const { width, height } = videoContainer.current.getBoundingClientRect();
      setOuterRatio(width / height);
    }
  };

  const updateVideoRatio = (width, height) => {
    setInnerRatio(width / height);
  };

  React.useEffect(() => {
    updateContainerRatio();
    window.addEventListener('resize', updateContainerRatio);

    return () => {
      window.removeEventListener('resize', updateContainerRatio);
    };
  }, []);

  return (
    <div
      style={containerStyle}
      ref={videoContainer}
      className={cx(styles.videoContainer, props.className)}
    >
      <video
        onLoadedData={event => {
          updateVideoRatio(event.target.videoWidth, event.target.videoHeight);
        }}
        style={style}
        playsInline
        autoPlay
        muted
        loop
      >
        <source src={props.url} type="video/mp4" />
      </video>
    </div>
  );
};

export default VideoCover;
